// extracted by mini-css-extract-plugin
export default {"container":"Kr-z","brandName":"Lr-z","productName":"Mr-z","productNamePdpEnhancements":"Nr-z","breakLongProductName":"Or-z"};